// extracted by mini-css-extract-plugin
export default {"land_main":"LandMain_land_main__j9PzY","land_main_content":"LandMain_land_main_content__QOA-C"};